<template>
  <el-dialog
    title="选择项目"
    :visible.sync="dialogVisible"
    class="dialog"
    width="900px"
    :before-close="handleClose"
  >
    <!--------查询-------->
    <el-form
      size="small"
      :inline="true"
      :model="filterForm"
      @submit.native.prevent
    >
      <el-form-item label="">
        <el-input
          v-model="filterForm.searchContent"
          class="search-input"
          placeholder="输入项目名称或委托方名称"
          clearable
          @keyup.enter.native="handleSearch"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <!--------表格----------->
    <el-table
      border
      :data="listData"
      size="medium"
      style="width: 100%"
      @current-change="clickChange"
    >
      <el-table-column label="选择" width="55">
        <template slot-scope="scope">
          <el-radio
            v-model="tableRadio"
            :label="scope.row.projectId"
          ><i></i></el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="index" label="序号" type="index" width="60" />
      <el-table-column
        prop="projectName"
        label="项目名称"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="isAgency"
        prop="purchaseCompanyName"
        label="委托方"
        min-width="180"
        show-overflow-tooltip
      />
      <el-table-column
        prop="publishEmployeeName"
        label="负责人"
        min-width="180"
        show-overflow-tooltip
      />
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
    />

    <!---------弹窗确认按钮------------>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="setProjectId"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
// 组件
import Pagination from '@/components/common/Pagination'

// mixins
import listFilterMixin from '@/mixins/list-filter-mixin'

// 数据字典
import { queryOrganizationDict } from '@/dictionary/query-status'

// 后端api
import { getAgentEntrustListApi } from '@/api/procure/entrust'
import { getPurchaseRegisterListApi } from '@/api/procure/register'

export default {
  components: {
    Pagination
  },

  mixins: [listFilterMixin],

  props: {
    /**
     * 是否是代理机构操作
     * 采购工作台选择项目登记-自主采购的
     * 代理机构选择 代理委托 & 项目登记-委托采购的
     */
    isAgency: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      dialogVisible: false,
      filterForm: {
        searchContent: ''
      },
      total: 0, // 总数量
      tableRadio: '',
      listData: []
    }
  },

  methods: {
    // 打开弹窗
    open(data) {
      this.dialogVisible = true
      this.tableRadio = data
      this.getList()
    },

    // 查询
    async getList() {
      this.epitaxy()

      const requestParams = {
        ...this.filterForm,
        page: this.page,
        size: this.size
      }

      if (!this.isAgency) {
        requestParams.projectOrgMethod =
          queryOrganizationDict.SELF_SOURCING.value
      }

      try {
        const requestApi = this.isAgency
          ? getAgentEntrustListApi
          : getPurchaseRegisterListApi
        const _data = await requestApi(requestParams)
        this.listData = _data.data.records || []
        this.total = _data.data.total || 0
      } catch (err) {
        this.$message.error(err.message || '获取项目列表失败')
      }
    },

    // 关闭弹窗
    handleClose() {
      this.tableRadio = ''
      this.filterForm = {
        searchContent: ''
      }
      this.dialogVisible = false
    },

    // 单选
    clickChange(item) {
      this.tableRadio = item ? item.projectId : this.tableRadio
    },

    /**
     * 得到projectId
     */
    setProjectId() {
      this.$emit('setProjectId', this.tableRadio)
      this.handleClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-input {
  ::v-deep &.el-input {
    width: 400px;
  }
}
</style>
